<div class="catalogue-item-dialog">
  <div class="catalogue-item-dialog-header flex-between-center">
    <div class="flex-start-center">
      <i class="fal fa-warehouse font-primary flex-center-center header-icon mr-2"></i>

      <p class="m-0 font-18 flex-column flex-center-start">
        <span *ngIf="catalogDialogType === 'supplier'" class="font-18 font-bold">
          Does this item exist in catalogue?
        </span>
        <span *ngIf="catalogDialogType === 'inventory'" class="font-18 font-bold">
          Add to existing inventory
        </span>

        <span *ngIf="catalogDialogType === 'supplier'" class="font-16 font-gray-55">
          Item name: {{onlineItem?.title}}
        </span>
        <span *ngIf="catalogDialogType === 'inventory'" class="font-16 font-gray-55">
          Add the item to catalogue first and set location to proceed
        </span>
      </p>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleCancel()"></i>
    </span>
  </div>

  <div class="catalogue-item-dialog-body flex-start-start">
    <i class="pr-2 {{searchTypeIcon[onlineItem?.type]}}"></i>
    <app-auto-complete name="catalogue-search" class="width-100p mt-3" styleClassListWrapper="top-38"
      styleClassError="top-35 left-10" field="title" listId="catalogue-search" inactiveItemsKey="status" theme="primary"
      noRecordText="No items match your search" styleClassInput="pl-0" scrollHeight="192px" [placeholder]="placeholder"
      [label]="placeholder" [hasEditableField]="true" [hasCustomEditableField]="true" [floatingLabel]="true"
      [selectTextOnFocus]="true" [isLoading]="isSearching" [selectionOnTab]="true" [highlightFirstSelectedValue]="true"
      [maxAutoGrowHeight]="96" [showDisabledIcon]="false" [selectInactiveItems]="false" [openDropdownOnGetResult]="true"
      [autoFocus]="true" [fontSize]="14" [isDropdownIconVisible]="true" [closeOnSelection]="true"
      [value]="associatedItems?.title" [suggestions]="itemResults" (appSelect)="handleSelect($event)"
      (appCompletedMethod)="handleSearchSuggestions($event)" (appClear)="handleClear()">
      <ng-template let-item appTemplate="item" let-query="query">
        <div class="service-item-details font-12 search-item flex-between-center"
          [ngClass]="{'disabled': !item?.status}">
          <div class="flex-start-center s-item-content-sec">
            <div class="flex-center-center mr-2">
              <i *ngIf="['part', 'tire'].includes(item?.type)" class="{{searchTypeIcon[item?.type]}} font-gray-75"></i>
            </div>

            <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
              <span class="flex-start-center font-secondary-700 text-truncate width-100p">
                <span *ngIf="item?.code && item?.type === 'part'">{{item?.code}}&nbsp;-&nbsp;</span>
                <div class="text-truncate text-span-break" tooltipPosition="top" [pTooltip]="item?.title"
                  [ngClass]="{'item-disabled not-allowed': associatedItems?.itemId}"
                  [innerHTML]="highlighedItemType(item?.title, query)"></div>
              </span>

              <!-- <strong>{{item?.stocked}}</strong> -->

              <span class="font-gray-55 tire-description text-truncate text-span-break" tooltipPosition="top"
                tooltipStyleClass="list-tooltip" [pTooltip]="item?.notes">
                {{item?.notes || 'No description'}}
              </span>
            </div>
          </div>

          <div class="flex-end-center s-item-price-sec">
            <div class="flex-column width-100p">
              <span *ngIf="item?.stocked && inventoryItems.includes(item?.type)" class="font-gray-55 content-end">
                Qty available: {{item?.countAvailable || 0}}
              </span>

              <span *ngIf="item?.stocked && inventoryItems.includes(item?.type)"
                class="font-gray-55 tire-description text-truncate">
                Qty on hand: {{item?.countInHand || 0}}
              </span>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template let-item appTemplate="editable">
        <p class="font-12 m-0 pl-1" (click)="handleOpenItemModal('create')">
          + Add new {{onlineItem?.type}}
        </p>
      </ng-template>
    </app-auto-complete>
  </div>

  <div class="catalogue-item-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">
      {{cancelBtnLabel}}
    </button>

    <button class="btn btn-primary btn-submit" [disabled]="!associatedItems?._id" (click)="handleSubmit()">
      {{saveBtnLabel}}
    </button>
  </div>
</div>
